export const IMG_TYPES = ['challenge', 'collection', 'cefr', 'native', 'compare', 'page'] as const;

export type ImgTypeType = (typeof IMG_TYPES)[number];
